<template>
	<div class="problem">
		<!-- PC端 -->
		<div class="problem_left">
			<ul class="problem_left_title" >
				<li class="problem_left_titles"><a href="/#">招募合伙人</a></li>
				<li class="problem_left_titles">拍界总部信息</li>
				<li v-for="(item,indexli) in companies" :key="indexli"  @click="toggleproTabs(indexli,0)" :class='{ current : showLi == indexli && showUl == 0 }'>{{item.title}}</li>
				<li class="problem_left_titles">拍界分部信息</li>
				<li v-for="(item,indexli) in branch_companies" :key="indexli"  @click="toggleproTabs(indexli,1)" :class='{ current : showLi == indexli && showUl == 1 }'>{{item.title}}</li>
			</ul>
		</div>
		<div class="problem_right">
			<ul class="problem_right_container" v-show="showUl === 0">
				<li class="problem_right_title" >拍界总部信息</li>
				<li v-for="(item,indexli) in companies" v-show="showLi === indexli">
					{{item.title}}
					<p v-if="item.name != undefined">联系人：{{item.name}}</p>
					<p>联系电话：{{item.phone}}</p>
					<p>地址：{{item.address}}</p>
					<p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
					<img v-for="image in JSON.parse(item.images)" :src="image.url" alt="">
				</li>
		
			</ul>
			<ul class="problem_right_container" v-show="showUl === 1">
				<li class="problem_right_title" >拍界分部信息</li>
				<li v-for="(item,indexli) in branch_companies" v-show="showLi === indexli">
					{{item.title}}
					<p v-if="item.name != undefined">联系人：{{item.name}}</p>
					<p>联系电话：{{item.phone}}</p>
					<p>地址：{{item.address}}</p>
					<p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
					<img v-for="image in JSON.parse(item.images)" :src="image.url" alt="">
				</li>
		
			</ul>
		</div>
		<!-- 移动端 -->
		<div class="problem_phone">
			<ul class="problem_left_title" >
				<li class="problem_left_titles"><a href="/partner">招募合伙人</a></li>
				<li class="problem_left_titles">拍界总部信息</li>
				<li v-for="(item,indexli) in companies">{{item.title}}
					<ul class="problem_phone_content">
						<li>
							<p v-if="item.name != undefined">联系人：{{item.name}}</p>
							<p>联系电话：{{item.phone}}</p>
							<p>地址：{{item.address}}</p>
							<p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
							<img v-for="image in JSON.parse(item.images)" :src="image.url" alt="">
						</li>
					</ul>
				</li>
				<li class="problem_left_titles">拍界分部信息</li>
				<li v-for="(item,indexli) in branch_companies">{{item.title}}
					<ul class="problem_phone_content">
						<li>
							<p v-if="item.name != undefined">联系人：{{item.name}}</p>
							<p>联系电话：{{item.phone}}</p>
							<p>地址：{{item.address}}</p>
							<p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
							<img v-for="image in JSON.parse(item.images)" :src="image.url" alt="">
						</li>
					</ul>
				</li>
			
			</ul>
		</div>
	</div>
</template>
<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界App，拍界官网，捡漏，拍卖，拍卖网，拍卖会，手机拍卖，微拍，微信拍卖，寻宝，收藏，拆除，二手设备，工厂，废旧物资，再生资源，回收，法拍房，法拍车，房产，司法拍"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	data (){
		return{
			companies:[],
			branch_companies:[],
			problemtabs:[
				{tab:'如何报名参加竞拍？'},
				{tab:'什么是流拍？'},
				{tab:'什么是标的物？'}
			],
			showUl: 0,
			showLi: 0
		}
	},
	created(){
		// 接收路由参数
		const curLi = this.$route.query.curLi;
		const curUl = this.$route.query.curUl;
		if (curLi !== undefined && curUl !== undefined){
			this.toggleproTabs(curLi,curUl)
		}

		this.axios.get("https://api.paijie.com/companies")
		.then((response) => {
			if(response.data.error.code == 0){
				this.companies = response.data.companies;
				this.branch_companies = response.data.branch_companies;
			}
		})
		.catch(() => {});

	},
	methods: {
		// tab切换
		toggleproTabs:function(showLi,showUl){
			this.showLi = showLi;
			this.showUl = showUl;
		}
	},
	mounted(){
		// 不是移动端则页面至顶部
		if(this.$route.query.isMobile == false){
			window.scrollTo(0,0)
		}else{
			document.getElementById('pm_rule').scrollIntoView();
		}
	}
}
</script>
